var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-section",class:{ 'page-section-condensed': _vm.condensed }},[_c('div',{staticClass:"page-section-heading"},[_vm._t("heading")],2),_c('div',{staticClass:"page-section-body"},[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }